"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarket = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const get_all_markets_1 = require("./get-all-markets");
const getMarket = (brand, iso2) => {
    const supportedBrand = (0, basic_types_1.asBrand)(brand);
    if (!supportedBrand) {
        return;
    }
    const market = get_all_markets_1.allMarkets[supportedBrand].find((m) => (0, basic_types_1.asIsoCountryCode2)(m.country.iso2) === (0, basic_types_1.asIsoCountryCode2)(iso2));
    return market;
};
exports.getMarket = getMarket;
